<template>
  <div
    class="overlay"
    @click="$emit('cancel')"
  />
  <div class="modal-wrapper">
    <div class="relative">
      <button
        v-if="showCloseButton"
        type="button"
        class="modal-close-button"
        @click="$emit('cancel')"
      >
        <CloseIcon />
      </button>
      <div v-if="title">
        <h3 class="text-lg leading-6 font-medium text-gray-900 mb-4">
          {{ title }}
        </h3>
      </div>

      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import CloseIcon from '@/components/icons/CloseIcon.vue';

export default defineComponent({
  name: 'BaseModal',
  components: {
    CloseIcon,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    showCloseButton: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['cancel'],
});
</script>

<style scoped>
.overlay {
  @apply fixed top-0 left-0 z-40 w-full h-full bg-black/50;
}

.modal-wrapper {
  @apply absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50
  flex flex-col gap-6 w-[650px] p-6 rounded-lg bg-white shadow-xl;
}

.modal-close-button {
  @apply absolute top-0 right-0 bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none transition-all duration-300;
}
</style>
